import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AbilityProvider } from '@/shared/permissions'

export const Route = createFileRoute('/_dashboard')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <AbilityProvider roles={[]}>
      <Outlet />
    </AbilityProvider>
  )
}
